export default __webpack_public_path__ + "static/media/ellipse_join_community_organisme.1c326180.svg";